function FacebookIcon() {
  return (
    <svg
      className='block dark:hidden hover:scale-110 transition'
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M23.75 0C25.8211 0 27.5 1.67894 27.5 3.75V23.75C27.5 25.8211 25.8211 27.5 23.75 27.5H3.75C1.67894 27.5 0 25.8211 0 23.75V3.75C0 1.67894 1.67894 0 3.75 0H23.75ZM23.75 2.5C24.4404 2.5 25 3.05965 25 3.75V23.75C25 24.4404 24.4404 25 23.75 25H17.5V16.2499H20.0953C20.6333 16.2499 21.1109 15.9056 21.2811 15.3951L21.8349 13.7339C22.0372 13.1267 21.5854 12.4999 20.9455 12.4999H17.5V9.9999C17.5 9.3749 18.125 8.7499 18.75 8.7499H21.25C21.9404 8.7499 22.5 8.19025 22.5 7.4999V6.64241C22.5 6.23864 22.2421 5.87662 21.8516 5.77359C20.2131 5.34119 18.75 5.34119 18.75 5.34119C15.625 5.34119 13.75 7.4999 13.75 9.3749V12.4999H11.25C10.5597 12.4999 10 13.0595 10 13.7499V14.9999C10 15.6902 10.5596 16.2499 11.25 16.2499H13.75V25H3.75C3.05965 25 2.5 24.4404 2.5 23.75V3.75C2.5 3.05965 3.05965 2.5 3.75 2.5H23.75Z'
        fill='#3A3A3A'
        stroke='#3A3A3A'
        strokeWidth='0.00064'
      />
    </svg>
  );
}

export default FacebookIcon;
